import { Avatar } from 'evergreen-ui'

import DockButton from '~/components/DockButton'
import DockShareLink from '~/components/DockShareLink'
import Flex from '~/components/Flex'
import Tool from '~/components/Tool'
import ToolGroup from '~/components/ToolGroup'
import { useActions, useStore } from '~/store/hooks'
import { toggleDrawer } from '~/utils/toggles'

export default function DockStateJoinTeam() {
  const team = useStore(actions => actions.account.team)
  const toggles = useStore(actions => actions.hud.toggles)
  const toggle = useActions(actions => actions.hud.toggle)

  return (
    <>
      <Flex justifyContent="flex-start">
        <ToolGroup>
          <Tool
            active={false}
            iconBefore={<Avatar name={team.name} size={24} src={team.avatar} />}
            label={`Join ${team.name} team as a Reviewer`}
            // name="drawer"
            onClick={() => toggleDrawer(toggles, toggle)}
          />
        </ToolGroup>
      </Flex>
      <Flex>
        <DockShareLink />
        <DockButton />
      </Flex>
    </>
  )
}
